import React, {useState, useEffect} from 'react';
import {useHistory} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";


const ReceiptgroupListComponent = (props) => {

  const [receiptgroup, setReceiptgroup] = useState([]);
  const {t} = props;
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [receipttypes, setReceipttypes] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });
  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      window.App.setState({rerenderReceiptgroupList: false});
      let query = window.App.transformQueryParams(lazyParams);
      if (query && !query.startsWith('?')) {
        try {
          const parsed = typeof query === 'object' ? query : JSON.parse(query);
          query = '?' + new URLSearchParams(parsed).toString();
        } catch (e) {
          query = '?' + query;
        }
      }
      apiCall('get', '/api/v2/receipt-group' + (query || ''))
        .then(response => {
          const payload = response.data && response.data.data ? response.data.data : {};
          setTotalRecords(payload.total_item_count || 0);
          setReceiptgroup(payload.items || []);
        })
        .catch(error => {
          window.App.toastShow('error', t('error') || 'Hiba történt!', error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    }, Math.random() * 1000 + 250);
  };
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_receipt_group_write') &&
        <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                tooltip={t('edit')} tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  // window.App.setState({
                  //   sidebarReceiptgroupUpdate: true,
                  //   props: rowData
                  // })
                  history.push('/finance/book/update/' + rowData.id);
                }}/>
        }
        {/*{localStorage.getItem('roles').toString().includes('role_receipt_group_write') &&*/}
        {/*<Button icon="pi pi-trash" className="  p-button-danger"*/}
        {/*        tooltip={t('delete')} tooltipOptions={{ position: 'left' }}*/}
        {/*        onClick={() => {*/}
        {/*          if (window.confirm('A törlés megerősítésére van szükség!')) {*/}
        {/*            deleteReceiptgroup(rowData)*/}
        {/*          }*/}
        {/*        }}*/}
        {/*/>*/}
        {/*}*/}
      </React.Fragment>
    );
  }

  const receipttypeAction = (rowData) => {
    if (!receipttypes || receipttypes.length === 0) {
      return rowData.receiptType;
    }
    const receipttype = receipttypes.find(item => item.id === rowData.receiptType);
    return receipttype ? receipttype.name : rowData.receiptType;
  };

  const loadReceipttypes = () => {
    apiCall('get', '/api/v2/dictionary/receipt-type')
      .then(response => {
        const data = (response.data && response.data.data) ? response.data.data : [];
        const transformedData = data.map(item => ({
          id: item.key,
          name: item.value
        }));
        setReceipttypes(transformedData);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      });
  };

  useEffect(() => {
    loadLazyData();
    loadReceipttypes();
  }, [lazyParams, window.App.state.rerenderReceiptgroupList === true, window.App.state.rerenderReceiptgroupList])

  return (
    <>
      {props && props.view === 'simple' &&
        <>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              {localStorage.getItem('roles').toString().includes('role_receipt_group_write') &&
                <a onClick={() => window.App.setState({sidebarReceiptgroupCreate: true})}
                   className={"p-button  p-button-success"}>
                  <i className={"pi pi-plus"}></i>
                  &nbsp;
                  {t('addReceiptGroup')}
                </a>
              }
            </div>
          </div>
        </>
      }
      <DataTable size={localStorage.getItem('scale')}
        emptyMessage={t('noResults')}
        value={receiptgroup} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows}
        autoLayout={true}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
      >
        <Column field="name" header={t('columnName2')} bodyClassName="col-body-font-bold" sortable filter filterPlaceholder={t('columnName2')}></Column>
        <Column field="receiptType" header={t('columnType')} sortable body={receipttypeAction}></Column>
        <Column field="income" header={t('columnMode')} sortable body={(rowData) => {
          if(rowData.outgoing === true) return <>Kimenő</>
          if(rowData.outgoing === false) return <>Bejövő</>
        }}></Column>
        <Column field="prefix" header={t('columnPrefix')} sortable filter filterPlaceholder={t('columnPrefix')}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ReceiptgroupListComponent);
